import { render, staticRenderFns } from "./cadastroPf.vue?vue&type=template&id=4043b17c&scoped=true&"
import script from "./cadastroPf.vue?vue&type=script&lang=js&"
export * from "./cadastroPf.vue?vue&type=script&lang=js&"
import style0 from "./cadastroPf.vue?vue&type=style&index=0&id=4043b17c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4043b17c",
  null
  
)

export default component.exports